import log from 'loglevel';

/**
 * 创建一个为 tagName 标签 element
 *
 * @export
 * @param {string} [tagName="div"]
 * @param {*} [properties={}]
 * @param {*} [attributes={}]
 * @returns HTMLElement
 */
export function createElement(tagName = 'div', properties = {}, attributes = {}) {
  const el = document.createElement(tagName);
  Object.getOwnPropertyNames(properties).forEach(prop => {
    el[prop] = properties[prop];
  });
  Object.getOwnPropertyNames(attributes).forEach(attr => {
    el.setAttribute(attr, attributes[attr]);
  });

  return el;
}

export function appendChild(parentId, child) {
  const parent = document.getElementById(parentId);
  if (!parent) {
    log.error(`doesn't exist parent element id: ${parentId}`);
    return;
  }

  if (!child) {
    log.error("doesn't exist child");
    return;
  }

  parent.appendChild(child);
}

/**
 * 判断某个元素是否包含某一个样式类
 *
 * @export
 * @param {*} el
 * @param {*} clazzName
 * @returns 返回是否包含样式类
 */
export function hasClass(el, clazzName) {
  if (el.classList) {
    return el.classList.contains(clazzName);
  }
  const reg = new RegExp('(^|\\s)' + clazzName + '($|\\s)');
  return reg.test(el.className);
}

/**
 * 为某一个元素添加一个样式类
 *
 * @export
 * @param {*} el
 * @param {*} clazz
 * @returns 返回添加样式后的元素
 */
export function addClass(el, clazz) {
  if (el.classList) {
    el.classList.add(clazz);
  } else if (!hasClass(el, clazz)) {
    el.className = (el.className + ' ' + clazz).trim();
  }
  return el;
}

/**
 * 为某一个元素移除一个样式
 *
 * @export
 * @param {*} el
 * @param {*} clazz
 * @returns 返回移除样式后的元素
 */
export function removeClass(el, clazz) {
  if (el.classList) {
    el.classList.remove(clazz);
  } else {
    el.className = el.className
      .split(/\s+/)
      .filter(c => {
        return c !== clazz;
      })
      .join(' ');
  }

  return el;
}

/**
 *某一个元素的某一个属性进行开关
 *
 * @export
 * @param {*} el
 * @param {*} clazzName
 * @param {*} predicate 可选参数为， 函数或者布尔类型，当传入函数的时候，则为一个回调，回调返回一个布尔类型
 * @returns toggle 元素的 某一个样式
 */
export function toggleClass(el, clazzName, predicate) {
  const has = hasClass(el, clazzName);
  // 回调
  if (typeof predicate === 'function') {
    predicate = predicate(el, clazzName);
  }

  // 如果是布尔值
  if (typeof predicate === 'boolean') {
    predicate = !has;
  }

  if (predicate === has) {
    return;
  }

  if (predicate) {
    addClass(el, clazzName);
  } else {
    removeClass(el, clazzName);
  }

  return el;
}

/**
 * 页面元素自己从父容器中移除
 *
 * @export
 * @param {*} el
 * @param {*} [callBK=null]
 */
export function removeFromParent(el, callBK = null) {
  if (!el) {
    return;
  }

  if (el.parentNode) {
    el.parentNode.removeChild(el);
  }

  callBK && callBK();
}

/**
 * 页面元素批量添加样式
 */
export function addStyle(el, styleObj) {
  if (Object.prototype.toString.call(styleObj) !== '[object Object]') {
    return;
  }
  for (let key in styleObj) {
    el.style[key] = styleObj[key];
  }
}

function getPrefix() {
  if (typeof document.hidden !== 'undefined') {
    return ['hidden', 'visibilitychange', 'visibilityState'];
  } else if ('mozHidden' in document) {
    return ['mozHidden', 'mozvisibilitychange', 'mozVisibilityState'];
  } else if ('msHidden' in document) {
    return ['msHidden', 'msvisibilitychange', 'msVisibilityState'];
  } else if ('webkitHidden' in document) {
    return ['webkitHidden', 'webkitvisibilitychange', 'webkitVisibilityState'];
  }
}

export function bindEventVisibility(callbackVisible, callbackHidden) {
  let prefix = getPrefix();
  document.addEventListener(
    prefix[1],
    function () {
      if (document[prefix[2]] === 'visible') {
        callbackVisible && callbackVisible();
      } else {
        callbackHidden && callbackHidden();
      }
    },
    false
  );
}

export function detectCssTransition() {
  const Detects = {
    transition: 'transitionend',
    WebkitTransition: 'webkitTransitionEnd'
    // 'MozTransition',
    // 'OTransition',
    // 'msTransition',
  };
  let el = document.createElement('div');
  let cssKeys = Object.keys(Detects);
  for (let key of cssKeys) {
    if (el.style[key] !== undefined) {
      return {
        css: key,
        event: Detects[key]
      };
    }
  }
  return false;
}

export function loadScript(id, url) {
  return new Promise((resolve, reject) => {
    if (document.getElementById(id)) {
      resolve();
    } else {
      let scriptEl = document.createElement('script');
      scriptEl.setAttribute('id', id);
      scriptEl.setAttribute('src', url);
      document.head.appendChild(scriptEl);
      scriptEl.onload = () => resolve();
      scriptEl.onerror = () => reject(Error('network error'));
      setTimeout(() => {
        reject(Error('timeout'));
      }, 10000);
    }
  });
}

export function clearAllNode(parentNode) {
  while (parentNode.firstChild) {
    parentNode.removeChild(parentNode.firstChild);
  }
}

export function getEventPrefix() {
  if (typeof document.hidden !== 'undefined') {
    return '';
  } else if ('mozHidden' in document) {
    return 'moz';
  } else if ('msHidden' in document) {
    return 'ms';
  } else if ('webkitHidden' in document) {
    return 'webkit';
  }
}
